import Button from '@/components/base/button/button';
import { type ForwardedRef, forwardRef } from 'react';

interface Props {
  href: string;
  title: string;
  className?: string;
}

export const HeaderNavigationLink = forwardRef<HTMLLIElement, Props>(
  (
    { href, title, className }: Props,
    ref: ForwardedRef<HTMLLIElement | null>,
  ) => {
    return (
      <li className={className} ref={ref}>
        <Button
          className="h-clickable w-max"
          variant="tertiary-no-frame"
          isLink
          href={href}
          testId={'header-navigation-link'}
        >
          <span className="whitespace-nowrap text-default text-nav-label">
            {title}
          </span>
        </Button>
      </li>
    );
  },
);
HeaderNavigationLink.displayName = 'HeaderNavigationLink';
